import React, {createRef, useEffect} from 'react'
import FJButton from "fj-components/FJButton";
import FJLocalStore from '../../../store/FJLocalStore'
import styles from './FJWatermarkImageBox.module.less'
import FJDeleteIcon from '../../../icon/FJGarbageIcon.svg';
import FJUploadIcon from '../../../icon/upload_logo.svg';
import FJWatermarkCommonView from "./FJWatermarkCommonView";
import FJInputFile from "fj-components/FJInputFile";
import FJImage from "fj-components/FJImage";
import FJImageRefresh from "fj-components/FJImageRefresh";
import retryIcon from '../../../icon/media-loading.png';
import classNames from 'classnames';
import FJViewConstant from "../../../constant/FJViewConstant";

function Button(props) {
  const {onClick, text, icon, inputFile, onChange, acceptType} = props;
  return (
  	<>
			<FJButton onClick={onClick}
								type='default'
								className={styles.button}
								textClass={styles.button_text}
								iconClass={styles.button_icon}
								icon={icon}
								text={text}/>
			<FJInputFile ref={inputFile}
									 onChange={onChange}
                   multiple={false}
									 accept={acceptType}/>
    </>
  );
}

function Loading() {
	return (
		<div className={classNames(styles.loading_img)}><img src={retryIcon}/></div>
	)
}

function DownLoading(props) {
	let {progress, leftDeg, rightDeg} = props;
	if (progress < 0.5) {
		leftDeg = progress / 0.5 * 180 - 135;
		rightDeg = -135;
	} else {
		leftDeg = 45;
		rightDeg = (progress - 0.5) / 0.5 * 180 - 135;
	}

	return (
		<div className={styles.progress_box}>
			<div className={styles.progress_container}>
				<div className={styles.load_outter}/>
				<div className={styles.load_left}>
					<div className={styles.load_inner} style={{
						transform: 'rotate(' + leftDeg + 'deg)',
						visibility: leftDeg === -135 ? 'hidden' : 'visible',
					}}/>
				</div>
				<div className={styles.load_right}>
					<div className={styles.load_inner} style={{
						transform: 'rotate(' + rightDeg + 'deg)',
						visibility: rightDeg === -135 ? 'hidden' : 'visible',
					}}/>
				</div>
				<span className={styles.load_value}>{Math.floor(progress * 100) + '%'}</span>
			</div>
		</div>
	)
}

function FJWatermarkImageBox(props) {

  const {
    active,
    url,
    onUpload,
    onRemove,
    watermarkSize,
    watermarkOpacity,
    setWatermarkParams,
    watermarkPosition,
		inputFile,
		onChange,
		acceptType,
    retry,
    thumbnailStatus,
    watermarkImageProgress,
		refresh
  } = props;

	const {MEDIA_STATUS_SUCCESS, MEDIA_STATUS_LOADING, MEDIA_STATUS_DOWNLOADING, MEDIA_STATUS_RETRY} = FJViewConstant;
	const retryRef = createRef();

	useEffect(() => {
	  if (thumbnailStatus === MEDIA_STATUS_RETRY) {
      retryRef.current.show();
    } else {
      retryRef.current.hide();
    }
  })

  return (
    <div style={{display: active ? 'block' : 'none'}}>
      <div className={styles.container}>
        <div className={styles.preview}>
          {
            thumbnailStatus === MEDIA_STATUS_SUCCESS ?
              <FJImage url={url}
                       className={styles.image}
                       retry={retry}
                       refreshClassName={refresh}
                       isShowDownLoadingStatus={true}
              /> : null
          }
          {thumbnailStatus === MEDIA_STATUS_LOADING && <Loading />}
          {thumbnailStatus === MEDIA_STATUS_DOWNLOADING && <DownLoading progress={watermarkImageProgress}/>}
          <FJImageRefresh ref={retryRef} refreshCallback={retry} />
        </div>
        <div className={styles.button_group}>
          <Button onClick={onUpload}
									text={FJLocalStore._('upload')}
									icon={FJUploadIcon}
									inputFile={inputFile}
									onChange={onChange}
									acceptType={acceptType}
					/>
          <Button onClick={onRemove} text={FJLocalStore._('remove')} icon={FJDeleteIcon}/>
        </div>
      </div>
      <FJWatermarkCommonView watermarkSize={watermarkSize}
                             watermarkOpacity={watermarkOpacity}
                             setWatermarkParams={setWatermarkParams}
                             watermarkPosition={watermarkPosition} />
    </div>
  );
}

export default FJWatermarkImageBox;